export default "__VITE_ASSET__DPBCwbZN__"